var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","disabled":_vm.disabled,"icon":""},on:{"click":function($event){return _vm.modules()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"blue-grey darken-1"}},[_vm._v("folder_open")])],1),_c('span',[_vm._v("Module")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }